import React, { Suspense, lazy, useContext, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { dashboardTrackingEvents, emitClarityTrackEvent } from '@/components/tracking/Clarity';

import { DashContext } from '../context';
import { collectSystems } from '../utils/collectSystems';

import { Button } from 'jpi-cloud-web-ui-kit';
import styled from 'styled-components';

const FilterModal = lazy(() => import(/* webpackChunkName: "FilterModal" */ '../../Systems/components/FilterModal'));

export enum SystemStatuses {
  ONLINE = 'online',
  OFFLINE = 'offline',
  WITHOUT_ALERT = 'withoutAlert',
  HAS_ALARM = 'hasAlarm',
  HAS_NOTIFICATION = 'hasNotification',
  HAS_FW_UPDATE = 'hasFwUpdate',
}

export interface IFilter {
  filterField: string;
  filterValue: SystemStatuses[];
}

export interface FilteringProps {
  onFilter: (f?: IFilter[]) => void;
  appliedFilters?: any;
}

const FilterButton = styled(Button)`
  &&& {
    border-radius: ${({ theme }) => theme.RADIUS.small};
    padding: ${({ theme }) => theme.spacing(1.25, 2)};
  }
`;

function Filtering({ onFilter, appliedFilters }: FilteringProps) {
  const [open, setOpen] = useState(false);
  const { systems, groups } = useContext(DashContext);

  // TODO: Check if changed filters are to be applied before close

  const openFilterModal = () => {
    if (!open) {
      emitClarityTrackEvent(dashboardTrackingEvents.FILTER_MODAL_OPEN);
    }
    setOpen(true);
  };

  const closeFilterModal = () => {
    setOpen(false);
  };

  const applyFilters = (appliedFilters: IFilter[] = []): void => {
    emitClarityTrackEvent(dashboardTrackingEvents.FILTER_APPLY_CLICK);
    onFilter(appliedFilters);
    setOpen(false);
  };

  const allSystems = [...systems, ...groups.map(collectSystems).flat()];

  return (
    <>
      <FilterButton
        dataCy="dashboard-filterBtn"
        size="medium"
        onClick={openFilterModal}
        variant="contained"
        color="primary"
        minWidth={80}
      >
        <FormattedMessage id="systems.button.filter" defaultMessage="Filter" />
      </FilterButton>
      <Suspense fallback={null}>
        <FilterModal
          systems={allSystems}
          appliedFilters={appliedFilters}
          showFilterModal={open}
          closeFilterModal={closeFilterModal}
          applyFilters={applyFilters}
        />
      </Suspense>
    </>
  );
}

export default Filtering;
